import { mapGetters } from 'vuex'
import globaltypes from '../../store/globaltypes'
export default {
  name: 'infobar',
  props: [],
  mounted () {

  },
  data () {
    return {
      show: false
    }
  },
  methods: {

  },
  computed: {
    ...mapGetters({
      information: globaltypes.main.getters.information
    })
  },
  watch: {
    information: function (val) {
      if (val) {
        this.show = true
      }
    }
  }
}
